<template>
  <div class="flex flex-col">
    <h3 class="text-display-small mb-4">{{ feedbackTopic.title }}</h3>
    <PulseProfileAnalysis
      :questions="questions"
      :topic-perspectives="perspectivesFromTopic(feedbackTopic)"
    />
  </div>
</template>
<script lang="ts" setup>
  import type { FeedbackTopic } from '../../../core/models/feedback-topic'
  import type { PulseQuestionAnalysis } from '@/core/models/surveys-analytics'
  import PulseProfileAnalysis from '@/core/components/analytics/PulseProfileAnalysis.vue'
  import { perspectivesFromTopic } from '@/core/models/perspective'

  interface Props {
    feedbackTopic: FeedbackTopic
    questions: ReadonlyArray<PulseQuestionAnalysis>
  }

  defineProps<Props>()
</script>
